export default "__VITE_ASSET__BCp$qWl6__"